<template>
  <div>
  <!-- <vue-scroll class="card-base card-shadow--medium mb-30" style="height:400px"> -->
    <div class="p-20 flex">
      <div class="box">
        <h4 class="mv-0 animated fadeInDown">{{title}}</h4>
      </div>
      <div class="box center"></div>
      <div class="box self-flex-end">
        <el-button :icon="loadingIcon" class="mr-5" size="small" @click="refresh" style="float:left;"></el-button>
        <el-dropdown v-if="id!=null">
          <el-button size="small">
            <i class="el-icon-more-outline"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" size="small">
            <el-dropdown-item :disabled="true"><i class="el-icon-setting"></i>{{$t('common.Configure')}}</el-dropdown-item>
            <el-dropdown-item @click.native="handleDelete" ><i class="el-icon-delete"></i>{{$t('common.Delete')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-skeleton :count="1" animated :loading="loading">
      <template slot="template">
        <tableSkeleton :rows="parseInt((height-250)/40)" :height="height-250" :columnLabel="[{ label:' ', width:50, sortable: false}, {label: $t('reservation.reservationNumber'), width:100, sortable:false}, {label: $t('reservation.customer'), sortable: true}, { label: $t('reservation.rep'), sortable: true}, {label: $t('reservation.product'), sortable: true}, {label: $t('reservation.reservedAt'), sortable: true}, {label: $t('reservation.qtyReserved'), width: 120, sortable: true}, {label: $t('reservation.qtyAvailable'), width: 120, sortable: true}]"></tableSkeleton>
      </template>
      <template>
        <reservationTable  class="mb-27" :reservations="reservations" :loading="false" :controls="false" :height="height-250"></reservationTable>
      </template>
    </el-skeleton>
    <div class="m-20 flex justify-space-between" style="display:absolute; top:20px;">
        <h4 class="mt-5 mb-0 o-050 fs-14 secondray-text">{{count}} {{ $t('reservation.reservationsFoundOutOf') }} {{totalCount}}</h4>
        <Pagination
          class="mt-5 mb-0 fs-14 secondary-text"
          :current-page="page"
          :total-number-of-page="totalPages"
          @click-previous="clickPrevious"
          @click-next="clickNext" />
    </div>
  <!-- </vue-scroll> -->
</div>
</template>
<script>
import reservationTable from './reservation-table'
 import reservationAPI from '@/services/API/reservation';
import moment from 'moment-timezone'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import Pagination from '@/components/pagination.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'reservation-order-dashboard-card',
	props: {
    uuid: {
      type: String
    },
    id : {
      type : Number
    },
    position : {
      type : Number,
      required: true,
    },
    filters : {
      type : Boolean,
      default : true
    },
    orderBy : {
      type : Object
    },
    filters : {
      type : Object
    },
    title : {
      type : String,
      default : null,
    },
    salesReps : {
      type : Array
    },
    height: {
      type: Number
    }
	},
  data() {
    return {
      user : null,
      loading : false,
      reservations : [],
      timer : '',
      totalCount : null,
      page : 1,
      totalPages : null,
    };
  },components: {
    reservationTable,
    tableSkeleton,
    Pagination
  },
	methods: {
    handleDelete(){
      this.deleteDashboard(this.id)
        .then(()=>{
          this.$message({
          message: 'Le canal a été supprimé avec succès.',
          type: 'success'
        });
        })
    },
    refresh () {
      this.cancelAutoUpdate();
      this.fetchReservations()
        .then(() => this.createTimer())
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.refresh();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.refresh();
      }
    },
    fetchReservations(){
      this.loading=true;
      let params = {};

      params.types = [];
      if (this.filters.productAvailable) params.types.push('active');
      if (this.filters.productToCome) params.types.push('delayed');
      if (this.filters.intent) params.types.push('intent');
      if (this.filters.completed) params.types.push('completed');

      params.redFlag = this.filters.redFlag?this.filters.redFlag:undefined;
      params.yellowFlag = this.filters.yellowFlag?this.filters.yellowFlag:undefined;
      params.greenFlag = this.filters.greenFlag?this.filters.greenFlag:undefined;
      params.salesRep = this.salesReps?this.salesReps:undefined;
      params.delayed = this.filters.delayed?this.filters.delayed:undefined;
      params.page = this.page;
      params.limit = 50;

      // console.log("params : ", params);

      return reservationAPI.fetchReservations(params).then(reservations => {
        this.reservations = reservations.list;
        this.totalCount = reservations.count;
        this.totalPages = reservations.pages;
        this.updateTotalElement({ uuid: this.uuid, totalElement: this.totalCount});
        this.loading=false;
      });
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    setSalesRepId(userId){
       this.fetchReservations();
    },
    createTimer () {
      this.timer = setInterval(this.fetchReservations, 60000 + (this.position * 2000));
    },
    cancelAutoUpdate () { clearInterval(this.timer) },
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('genericDashboards', ['updateTotalElement','deleteDashboard']),
	},
	computed: {
    loadingIcon(){
      if(this.loading)return 'el-icon-loading'
      else return 'el-icon-refresh'
    },
    count(){
      if(this.reservations==null)return 0;
      else return this.reservations.length;

    },
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
	},
  created(){
    this.user = JSON.parse(localStorage.user);
    this.fetchReservations()
      .then(() => this.createTimer())
    this.fetchAdminUsers();

  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>
<style lang="scss" scoped>




</style>
